import { AccountInfo } from "@azure/msal-browser";

export function getAccountEmail(info: AccountInfo | undefined): string {
  if (!info?.idTokenClaims) return "";

  const idToken = info.idTokenClaims as { email: string };
  return idToken.email ?? "";
}
